import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { useCompanyInfo, useReviews } from '../lib/cms';
import { imageUrl } from '../lib/images';

export default function KomposithegnPage() {
  const companyInfo = useCompanyInfo();
  const reviews = useReviews();
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    // 1# Komposithegn sort pulverlakeret
    { src: "/_assets/pxl-20260710-142506610.jpg", title: "Sort pulverlakeret komposithegn i skel" },
    { src: "/_assets/pxl-20260710-142439967.jpg", title: "Sort pulverlakeret komposithegn mod vej" },
    { src: "/_assets/pxl-20260710-142248728.jpg", title: "Sort pulverlakeret komposithegn detalje" },
    { src: "/_assets/pxl-20260626-135051675-mp.jpg", title: "Sort komposithegn ved gult murstenshus" },
    { src: "/_assets/pxl-20260626-134228707.jpg", title: "Komposithegn sort pulverlakeret i indkørsel" },
    { src: "/_assets/pxl-20260427-130943932.jpg", title: "Sort komposithegn og låge ved carport" },
    { src: "/_assets/pxl-20260427-130837583.jpg", title: "Komplet sort komposithegnsløsning ved villa" },
    // 4# Komposithegn
    { src: "/_assets/pxl-20260703-095205669.jpg", title: "Sort komposithegn om hjørnegrund" },
    { src: "/_assets/pxl-20260622-105620052-mp.jpg", title: "Brunt komposithegn med stålstolper" },
    { src: "/_assets/pxl-20260615-140042784.jpg", title: "Komposithegn ved indkørsel" },
    { src: "/_assets/pxl-20260608-112249497.jpg", title: "Komposithegn langs flisegang og teknikskab" },
    { src: "/_assets/pxl-20260522-165345604-mp.jpg", title: "Komposithegn med to låger" },
    { src: "/_assets/pxl-20260430-173443839.jpg", title: "Koksgråt komposithegn med låge på fliser" },
    { src: "/_assets/pxl-20260420-113446037.jpg", title: "Kompositlåge og hegn ved indkørsel" },
    // Øvrige referencer
    { src: "/_assets/485170711-1308137817341082-5036954073090041011-n.jpg", title: "Komposithegn i have" },
    { src: "/_assets/471191501-1114845036682617-6842805619149679997-n.jpg", title: "Komposithegn terrasse" },
    { src: "/_assets/487299722-1317946333026897-8302200838072951330-n.jpg", title: "Komposithegn med stolper" },
    { src: "/_assets/289542062-562295725270887-1557145661797255469-n.jpg", title: "Komposithegn sort" },
    { src: "/_assets/komphegn12.jpeg", title: "Komposithegn montage" },
    { src: "/_assets/thumbnail-1000002638.jpg", title: "Komposithegn haveafskærmning" },
    { src: "/_assets/thumbnail-1000002945.jpg", title: "Komposithegn mørkt trælook" },
    { src: "/_assets/thumbnail-1000003382.jpg", title: "Komposithegn have" },
    { src: "/_assets/thumbnail-1000003710.jpg", title: "Komposithegn på mål" },
    { src: "/_assets/thumbnail-img20241015151231.jpg", title: "Komposithegn detaljer" },
    { src: "/_assets/thumbnail-img20231222124518.jpg", title: "Komposithegn vedligeholdelsesfrit" },
    { src: "/_assets/6043-1.jpg", title: "Komposithegn havehegn" },
    { src: "/_assets/6058.jpg", title: "Komposithegn indkørsel" },
    { src: "/_assets/img20250930153748-1.jpg", title: "Komposithegn afskærmning" },
    { src: "/_assets/thumbnail-img20250717075857.jpg", title: "Komposithegn Fyn" },
  ];

  return (
    <>
      <SEO
        title="Komposithegn af 100% kvalitet | Landsdækkende | Ring nu"
        description="Et vedligeholdelsesfrit hegn? Så er et komposithegn svaret. Det kræver kun rengøring en gang imellem. Kontakt Hovendals og få tilbud i dag."
        ogImage="/_assets/487299722-1317946333026897-8302200838072951330-n-0.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/487299722-1317946333026897-8302200838072951330-n-0.jpg", "width=1600,quality=80,format=auto")}
            alt="Komposithegn"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-leaf" aria-hidden="true"></i>
              <span>Vedligeholdelsesfrit hegn</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Komposithegn - drømmer du om vedligeholdelsesfrit hegn
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Et hegn i komposit er den ideelle løsning til dig, der ønsker et smukt og holdbart hegn med et minimum af vedligeholdelse.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section 1 & 2 */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Fordele ved komposit</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Vedligeholdelsesfrit hegn i komposit
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                Vedligeholdelsesfrit hegn / komposithegn er blevet en utrolig populær løsning hos de danske husejere. Den stigende popularitet skyldes uden tvivl, at et hegn i komposit er vedligeholdelsesfrit, hvilket tiltaler de fleste. Det eneste du skal, er at vaske hegnet ned en gang i mellem. Når du vasker hegnet ned, forbliver det pænt. Du slipper altså for at male dit træhegn år efter år.
              </p>

              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  Komposithegn med naturligt trælook i mørke nuancer
                </h3>
                <p className="text-slate-700 leading-relaxed text-base">
                  Komposithegnet har med dets struktur et udtryk af at være rigtigt træ i mørke farver, hvilket får det til at fremstå som et naturligt træhegn. Hos Hovendals har vi mange års erfaring med at designe og montere komposithegn, og vi hjælper kunder i Odense, Aalborg, Silkeborg, Gentofte og resten af Danmark. Tøv ikke med at kontakte os allerede i dag.
                </p>
              </div>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-envelope" aria-hidden="true"></i>
                  <span>Skriv en mail</span>
                </a>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/komposithegn-laage.webp", "width=1200,quality=85,format=auto")}
                alt="Mørkegråt komposithegn med låge ved moderne bolig"
                className="w-full h-auto aspect-[16/10] object-cover"
              />
            </div>
          </div>

          {/* Section 3: Efter dine mål */}
          <div className="bg-slate-50 rounded-2xl p-8 sm:p-12 border border-slate-200/80 mb-16">
            <div className="max-w-3xl space-y-4">
              <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Specialtilpasset</span>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Komposithegn efter dine mål
              </h2>
              <p className="text-[#4B515D] leading-relaxed text-base">
                Hos Hovendals fremstiller vi komposithegn på mål med fokus på kvalitet, holdbarhed og flot design. Vi leverer skræddersyede løsninger til kunder i hele Danmark.
              </p>
              <p className="text-slate-700 leading-relaxed text-base">
                Helt lavpraktisk betyder det, at vi kommer ud til dig, måler op, hvorefter vi laver hegnet på vores værksted. Du er derfor sikret, at hegnet er 100% designet efter din haves mål samt dine ønsker til hegnet. Når hegnet er færdigt, kommer vi ud og monterer det på adressen, så du hurtigt kan nyde godt af dit nye hegn. <Link to="/kontakt" className="text-[#004fa4] font-bold hover:underline">Kontakt os</Link>, og få en skarp pris på dit nye komposithegn inkl. montering.
              </p>
              <p className="text-slate-700 leading-relaxed text-base">
                Herunder har vi samlet et udpluk af komposithegn, vi har lavet. Designet varierer efter kundens ønske, så det passer til deres stil og drømme.
              </p>
              <div className="pt-2">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all"
                >
                  <span>Hør mere om komposithegn</span>
                  <i className="fa-sharp fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          </div>

          {/* Reviews snippet */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center">
              Anbefalinger fra tilfredse hegnskunder
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {reviews.slice(0, 3).map((rev, idx) => (
                <div key={idx} className="p-6 rounded-xl bg-white border border-slate-200 shadow-sm flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-1 text-[#004fa4] text-xs mb-2">
                      {[...Array(rev.rating)].map((_, i) => (
                        <i key={i} className="fa-sharp fa-solid fa-star" aria-hidden="true"></i>
                      ))}
                    </div>
                    <div className="font-bold text-slate-900 text-sm mb-2">{rev.title}</div>
                    <p className="text-xs text-slate-600 italic leading-relaxed mb-4">"{rev.text}"</p>
                  </div>
                  <div className="text-xs font-bold text-slate-800">{rev.author}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Billedgalleri */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">
              Udpluk af komposithegn vi har lavet
            </h3>
            <p className="text-sm text-slate-600 mb-6">
              Klik på et billede for at se det i stor størrelse.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-48 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=400,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2 rounded-full bg-[#143463]/90 text-white text-xs">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Section 4: Pris og uforpligtende tilbud */}
          <div className="bg-slate-900 text-white rounded-2xl p-8 sm:p-12 mb-12">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-4">
              Få en pris samt et uforpligtende tilbud på vedligeholdelsesfrit komposithegn
            </h2>
            <p className="text-slate-300 leading-relaxed text-base mb-4">
              Står du og ønsker dig et vedligeholdelsesfrit hegn i haven? Så kontakt Hovendals og få et uforpligtende tilbud på komposithegn / vedligeholdelsesfrit hegn. Prisen på et komposithegn varierer rigtigt meget, da det bl.a. kommer an på, hvor højt og langt hegnet skal være, om der er mange knæk og hjørner, som hegnet skal tilpasses. Det er derfor ikke muligt at give en pris, som er en guideline for, hvad det vil koste i din have, indkørsel osv.
            </p>
            <p className="text-slate-300 leading-relaxed text-base mb-6">
              Men du er altid velkommen til at kontakte os på <a href={`tel:${companyInfo.phoneFormatted}`} className="text-[#c2ccdf] font-bold hover:underline">{companyInfo.phone}</a> eller sende en mail til <a href={`mailto:${companyInfo.email}`} className="text-[#c2ccdf] font-bold hover:underline">{companyInfo.email}</a> også vender vi tilbage hurtigst muligt.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href={`tel:${companyInfo.phoneFormatted}`}
                className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
              >
                <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                <span>Ring os op</span>
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="px-6 py-3 rounded-lg bg-slate-800 hover:bg-slate-700 text-white font-bold text-sm transition-all flex items-center gap-2 border border-slate-700"
              >
                <i className="fa-sharp fa-solid fa-envelope" aria-hidden="true"></i>
                <span>Skriv en mail</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
